import { useCallback } from 'react';
import { useAuth } from '@/contexts/ContextoAuth';
import { usuariosService } from '@/services/api/usuarios.service';

export function useOnboarding(userId?: string | null) {
  const { user, updateUser } = useAuth();
  const mostrar = !!userId && !!user?.esOnboarding;

  const marcarVisto = useCallback(() => {
    if (!userId) return;
    updateUser({ esOnboarding: false });
    usuariosService.marcarOnboarding(userId, false).catch(() => {});
  }, [userId, updateUser]);

  return { mostrar, marcarVisto };
}
